import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck, CreditCard, Lock } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-2 pb-6 md:pt-20 md:pb-24 overflow-hidden bg-white" data-id="element-142">
      {/* Background gradients */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/10 blur-[100px] rounded-full pointer-events-none" data-id="element-143" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-144">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-center" data-id="element-145">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-red-50 text-red-600 font-semibold text-[10px] md:text-sm mb-2 md:mb-8 border border-red-100" data-id="element-146">
            <span className="relative flex h-2 w-2 md:h-3 md:w-3" data-id="element-147">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-148"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 md:h-3 md:w-3 bg-red-500" data-id="element-149"></span>
            </span>
            ITERA PRO™
          </div>

          <h1 className="text-lg md:text-6xl font-extrabold tracking-tight text-gray-900 mb-1.5 md:mb-6 leading-snug" data-id="element-150">
            Todo tu negocio de Airbnb Manager.{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary" data-id="element-151">
              Listo. Desde hoy.
            </span>
          </h1>

          {/* Product Image */}
          <div className="mb-2 md:mb-8 max-w-[180px] md:max-w-2xl mx-auto" data-id="element-152">
            <img src="https://cdn.magicpatterns.com/uploads/44peSDLbbyop6aPUkcLHbf/ChatGPT_Image_May_4,_2026,_02_21_41_AM.png" alt="Megapack Operativo Airbnb Manager - 6 Tomos + 6 Bonos - Sistema Completo" className="w-full h-auto rounded-xl md:rounded-2xl md:pl-[75px] md:pr-[75px]" data-id="element-153" />
          </div>

          <p className="text-xs md:text-lg text-gray-500 mb-1 md:mb-4 max-w-2xl mx-auto leading-snug" data-id="element-154">
            El sistema N°1 para gestores de propiedades en Argentina — Sin
            propiedad propia — Con ingresos en USD
          </p>

          {/* Secondary description - hidden on mobile */}
          <p className="hidden md:block text-base text-gray-400 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-155">
            Contratos + operaciones + finanzas + automatización listos para
            usar. Sin improvisar. Sin empezar desde cero.
          </p>

          {/* Trust Badges Row - hidden on mobile to save space */}
          <div className="hidden md:flex flex-wrap justify-center gap-3 md:gap-6 mb-10" data-id="element-156">
            {[{
            icon: '📄',
            text: '100% PDF'
          }, {
            icon: '⚡',
            text: 'Acceso en 5 min'
          }, {
            icon: '🇦🇷',
            text: 'Para Argentina'
          }, {
            icon: '💵',
            text: 'Ingresos en USD'
          }].map((badge, i) => <div key={i} className="flex items-center gap-2 bg-surface px-4 py-2 rounded-full text-sm font-medium text-gray-700 border border-gray-100 shadow-sm" data-id="element-157">
                <span data-id="element-158">{badge.icon}</span>
                {badge.text}
              </div>)}
          </div>

          <motion.a href="#pricing" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center justify-center w-full sm:w-auto px-5 py-2.5 md:px-8 md:py-4 text-sm md:text-lg font-bold text-white bg-gradient-to-r from-primary to-secondary rounded-xl md:rounded-2xl shadow-lg shadow-primary/25 hover:shadow-xl hover:shadow-primary/30 transition-all mt-2 md:mt-0" data-id="element-159">
            🔴 QUIERO MI MEGAPACK AHORA
          </motion.a>

          {/* Security Badges */}
          <div className="flex flex-wrap justify-center items-center gap-2 md:gap-8 mt-2.5 md:mt-6 text-[10px] md:text-sm text-gray-500 font-medium" data-id="element-160">
            <div className="flex items-center gap-1" data-id="element-161">
              <ShieldCheck className="w-3 h-3 md:w-4 md:h-4 text-green-500" data-id="element-162" />{' '}
              Garantía 7 días
            </div>
            <div className="flex items-center gap-1" data-id="element-163">
              <Lock className="w-3 h-3 md:w-4 md:h-4 text-gray-400" data-id="element-164" /> Pago
              seguro
            </div>
            <div className="flex items-center gap-1" data-id="element-165">
              <CreditCard className="w-3 h-3 md:w-4 md:h-4 text-blue-500" data-id="element-166" />{' '}
              Mercado Pago
            </div>
          </div>

          {/* Stats Row */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-8 mt-6 md:mt-16 pt-4 md:pt-10 border-t border-gray-100" data-id="element-167">
            {[{
            value: '+300',
            label: 'managers confían'
          }, {
            value: '6',
            label: 'Tomos listos'
          }, {
            value: '6',
            label: 'Bonos incluidos'
          }, {
            value: '4.9/5',
            label: 'calificación ⭐'
          }].map((stat, i) => <div key={i} className="text-center" data-id="element-168">
                <div className="text-xl md:text-3xl font-extrabold text-gray-900 mb-0.5" data-id="element-169">
                  {stat.value}
                </div>
                <div className="text-[10px] md:text-sm text-gray-500 font-medium" data-id="element-170">
                  {stat.label}
                </div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}